import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { Auth } from 'aws-amplify';

import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles(theme => ({
  grid: {
    marginTop: theme.spacing(10),
    textAlign: 'center'
  },
  paper: {
    padding: theme.spacing(3),
    textAlign: 'left'
  },
  msg: {
    marginTop: '12px',
    color: '#f44336',
    fontWeight: '500',
  },
  msglink: {
    fontWeight: '700',
    '&:hover': {
      color: "#00b2ad",
      textDecoration: 'underline'
    },
  },
  progress: {
    marginTop: '8px'
  },
  forgot: {
    marginTop: '12px',
    fontWeight: '500',
    textDecoration: 'none',
    textAlign: 'center',
    color: '#777',
    '&:hover': {
      color: "#00b2ad",
      textDecoration: 'underline'
    },
  },
  buttons: {
    marginTop: theme.spacing(3)
  },
}));

const Login = (props) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [formMsg, setFormMsg] = useState("");
  const [isWaiting, setIsWaiting] = useState(false);
  const [isCodeMsg, setIsCodeMsg] = useState(false);
  const [isRegisterMsg, setIsRegisterMsg] = useState(false);
  const [isPasswordMsg, setIsPasswordMsg] = useState(false);

  const history = useHistory();

  const validateForm = () => {
    if (email.length === 0) {
      setFormMsg("Please enter an email address.");
      return false;
    }
    if (email.indexOf("@") === -1 || email.length <= 3) {
      setFormMsg("Please enter a valid email address.");
      return false;
    }
    if (password.length === 0) {
      setFormMsg("Please enter a password.");
      return false;
    }
    return true;
  };
  const handleResetPassword = async () => {
    history.push("/reset");
  }
  const handleRegister = async () => {
    history.push("/register");
  }
  const handleActivate = async () => {
    history.push("/activate");
  }
  const handleSubmit = async (event) => {
    event.preventDefault();

    setIsCodeMsg(false);
    setIsRegisterMsg(false);
    setIsPasswordMsg(false);

    if (validateForm()) {
      setIsWaiting(true);
      setFormMsg("Authenticating ...");
      try {
        const user = await Auth.signIn(email, password);
        setFormMsg("Authenticating ... Success.");
        setIsWaiting(false);
        setFormMsg("");
        props.setUser(user);
        props.userHasAuthenticated(true);
        history.push("/event");
      } catch (e) {
        setFormMsg("");
        setIsWaiting(false);
        if (e.code === 'UserNotConfirmedException') {
          setIsCodeMsg(true);
        } else if (e.code === 'PasswordResetRequiredException') {
          setIsPasswordMsg(true);
        } else if (e.code === 'NotAuthorizedException') {
          setFormMsg(e.message);
        } else if (e.code === 'UserNotFoundException') {
          setIsRegisterMsg(true);
        } else {
          console.log(e);
          setFormMsg(e.message);
        }
      }
    }
  };

  const classes = useStyles();
  return (
    <Container>
    <Grid container justify='center'>
      <Grid item xs={10} sm={8} md={6} lg={5} className={classes.grid}>
        <Paper className={classes.paper}>
          <h2>Login</h2>
          <form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <TextField
              id="username"
              label="Email"
              onChange={e => setEmail(e.target.value.trim().toLowerCase())}
              margin="normal"
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              fullWidth
              autoFocus
            />
            <TextField
              id="password"
              label="Password"
              type="password"
              onChange={e => setPassword(e.target.value)}
              margin="normal"
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              fullWidth
            />
            <Grid container spacing={1}>
              <Grid item>
                <Button type="submit" variant="outlined" color="secondary" disabled={isWaiting}>
                  Login
                </Button>
              </Grid>
              <Grid item>
                {isWaiting && (
                  <CircularProgress size={20} className={classes.progress} />
                )}
              </Grid>
              <Grid item style={{flexGrow: 1}}>
                { formMsg && formMsg.length > 0 &&
                  <h5 className={classes.msg}>{formMsg}</h5>
                }
                {
                  isCodeMsg &&
                  <h5 className={classes.msg}>Your account is not confirmed. Please <Link to="/activate" className={classes.msglink}>resend confirmation code</Link>, and complete the activation.</h5>
                }
                {
                  isRegisterMsg &&
                  <h5 className={classes.msg}>Email not found. You might need to <Link to="/register" className={classes.msglink}>register</Link> first?</h5>
                }
                {
                  isPasswordMsg &&
                  <h5 className={classes.msg}>Your password needs to be <Link to="/reset" className={classes.msglink}>reset</Link> before you can login.</h5>
                }
              </Grid>
            </Grid>
          </form>
        </Paper>
        <div className={classes.buttons}>
          <ButtonGroup color="secondary" variant="contained">
            <Button onClick={handleResetPassword}>Forgot password?</Button>
            <Button onClick={handleRegister}>Register</Button>
            <Button onClick={handleActivate}>Activate account</Button>
          </ButtonGroup>
        </div>

        {/* <Grid container>
          <Grid item xs={4}>
            <div className={classes.forgot}><Link to="/reset"> Forgot password? </Link></div>
          </Grid>
          <Grid item xs={4}>
            <div className={classes.forgot}><Link to="/register"> Register </Link></div>
          </Grid>
          <Grid item xs={4}>
            <div className={classes.forgot}><Link to="/activate"> Activate account </Link></div>
          </Grid>
        </Grid> */}

      </Grid>
    </Grid>
    </Container>
  );
};

export default Login;